export default {"src":"/_next/static/media/expertiseIcon.49b433ec.svg","height":31,"width":32,"blurWidth":0,"blurHeight":0};